import React, { PropTypes } from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import ReactCrop from 'react-image-crop';
import LoadingSpinner from '../LoadingSpinner';
import 'react-image-crop/dist/ReactCrop.css';

class CropImage extends React.Component {
  static propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
    onCrop: PropTypes.func.isRequired,
    onClose: PropTypes.func,
    dataUri: PropTypes.string.isRequired
  };

  state = {
    crop: {}
  };

  handleCloseCrop() {
    if (this.props.onClose) {
      this.props.onClose();
    }
  }

  handleCrop() {
    this.props.onCrop(this.state.crop);
    this.handleCloseCrop();
  }

  componentDidMount() {
    this.configCrop(this.props);
  }

  componentWillReceiveProps(newProps) {
    this.configCrop(newProps);
  }

  configCrop(props) {
    let { width, height } = props;
    let { crop } = this.state;

    if (width && height) {
      crop = Object.assign(crop, {
        aspect: width / height
      });
    }

    this.setState({ crop });
  }

  updateCrop(crop) {
    this.setState({ crop });
  }

  onImageLoaded(image) {
    let { width, height } = this.props;

    let newState = Object.assign({}, this.state, { image });

    if (width) {
      let minWidth = (width / image.naturalWidth) * 100;
      newState = Object.assign(newState, {
        crop: Object.assign({}, newState.crop, {
          x: (100 - minWidth) / 2,
          width: minWidth
        }),
        minWidth
      });
    }

    if (height) {
      let minHeight = (height / image.naturalHeight) * 100;
      newState = Object.assign(newState, {
        crop: Object.assign({}, newState.crop, {
          y: (100 - minHeight) / 2,
          height: minHeight
        }),
        minHeight
      });
    }

    this.setState(newState);
  }

  getActions() {
    return [
      <FlatButton
        label="Cancel"
        secondary={true}
        onClick={() => this.handleCloseCrop()}
      />,
      <FlatButton
        label="Crop"
        primary={true}
        onClick={() => this.handleCrop()}
      />
    ];
  }

  render() {
    // eslint-disable-next-line no-unused-vars
    let { crop, minWidth, minHeight, open, image } = this.state;
    let { dataUri } = this.props;

    let cropParams = {
      keepSelection: true,
      minHeight,
      minWidth
    };

    return (
      <Dialog
        title="Crop image"
        actions={this.getActions()}
        open={true}
        autoScrollBodyContent={true}
        onRequestClose={() => this.handleCloseCrop()}
      >
        <LoadingSpinner show={image === undefined}>{null}</LoadingSpinner>

        <ReactCrop
          src={dataUri}
          onImageLoaded={(crop, image) => this.onImageLoaded(image)}
          crop={crop}
          onComplete={cropValue => this.updateCrop(cropValue)}
          {...cropParams}
        />
      </Dialog>
    );
  }
}

export default CropImage;



// WEBPACK FOOTER //
// ./src/components/form/CropImage.jsx